import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { SabisButton2Component, SabisNgxDialogComponent } from 'sabis-components2';
import { finalize, Subscription } from 'rxjs';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormValues, SABISDynamicformComponent, SABISDynamicFormModule } from 'sabis-dynamicform';
import { EditorData } from 'sabis-dynamicform-core/cjs/Models/DynamicFormModel';
import { AppLoaderService } from '../../../../@theme/shared/services/app-loader/app-loader.service';
import { AppNotificationsService } from '../../../../core/notifications/app-notifications.service';
import { ReferenceCheckPublicService } from '../../../../public/feedback-request/feedback-request-public.service';
import { FormInstanceService } from '../../../../shared/dynamic-forms/instances/form-instance.service';
import { ReferenceCheckRequestListInitDTO, FeedbackRequestsService } from '../feedback-requests.service';
import { AppNavigationService } from './../../../../core/navigation/app-navigation.service';
import { ApplicationFeedbackType } from '../../models/api-models';
import { MatStepperModule } from '@angular/material/stepper';

@Component({
  selector: 'sca-feedback-requests-list',
  templateUrl: './feedback-requests-list.component.html',
  styleUrls: ['./feedback-requests-list.component.scss'],
  imports: [
    MatStepperModule,
    SabisNgxDialogComponent,
    SabisButton2Component,
    SABISDynamicFormModule
  ]
})
export class FeedbackRequestsListComponent implements OnInit, OnDestroy {
  private _initReferenceCheckRequestsSubscription: Subscription = new Subscription();

  public isLoading: boolean = false;

  public feedbackRequestInfo!: ReferenceCheckRequestListInitDTO;
  private _feedbackRequestId: number;

  public userEmail: string = '';
  public feedbackRequestPublicId: string = '';
  public isFeedbackAnswered: boolean = false;
  public isFeedbackCanceled: boolean = false;
  public feedbackFormValues: FormValues | null = null;

  public formInstanceInitData: EditorData | null = null;

  public canLockFeedbackForm: boolean = this.data.canLockFeedbackForm;
  public hasRegionalManagerAccess: boolean = false;

  public canView: boolean = false;// can view the feedback response

  private _applicationId: number = 0;
  private _selectionStepId: number = 0;

  public isSaving: boolean = false;
  @ViewChild('formEditor', { static: false }) formEditor!: SABISDynamicformComponent;

  constructor(private _referenceCheckService: FeedbackRequestsService,
    private _referenceCheckPublicService: ReferenceCheckPublicService,
    public dialogRef: MatDialogRef<FeedbackRequestsListComponent>,
    private _formInstanceService: FormInstanceService,
    private _appLoader: AppLoaderService,
    private _appNotifications: AppNotificationsService,
    private _navigation: AppNavigationService,
    @Inject(MAT_DIALOG_DATA) public data: ReferenceCheckRequestDialogData,) {
    this._feedbackRequestId = data.feedbackRequestId;
  }

  ngOnInit(): void {
    this.getInitData();
  }

  ngOnDestroy(): void {
    this._initReferenceCheckRequestsSubscription.unsubscribe();
  }

  private getInitData(): void {
    this.isLoading = true;

    this._initReferenceCheckRequestsSubscription = this._referenceCheckService.getReferenceCheckRequests(this._feedbackRequestId).subscribe(r => {
      this.feedbackRequestInfo = r;
      this.hasRegionalManagerAccess = r.hasRegionalManagerAccess;
      if (r.requests != null) {
        this.userEmail = r.requests.userEmail;
        this.isFeedbackAnswered = r.requests.answered;
        this.isFeedbackCanceled = r.canceled;
        this.feedbackRequestPublicId = r.requests.publicId;
        this.feedbackFormValues = r.requests.feedbackFormValues;
        this.canView = r.canView;
        this._applicationId = r.applicationId;
        this._selectionStepId = r.selectionStepId;
      }

      this.formInstanceInitData = r.editorInitData;

      this.isLoading = false;
    });
  }

  public onDeleteRequestClick(): void {
    this._appNotifications.confirmDeleteFeedbackRequest().subscribe(c => {
      if (c) {
        this._referenceCheckService.deleteRequestClick(this._feedbackRequestId)
          .pipe(
            finalize(() => {
              this.isSaving = false;
              this._appLoader.hideSaving();
            })
          )
          .subscribe({
            next: () => {
              this._appNotifications.notifyDeleteSucceeded();
              this.dialogRef.close(true);
            }
          });
      }
    });
  }

  public onCancelRequestClick(): void {
    this._appNotifications.confirmCancelRequest().subscribe(c => {
      if (c) {
        this._referenceCheckPublicService.cancelFeedbackRequest(this._feedbackRequestId)
          .pipe(
            finalize(() => {
              this.isSaving = false;
              this._appLoader.hideSaving();
            })
          )
          .subscribe({
            next: () => {
              this._appNotifications.notifySaveSucceeded();
              this.dialogRef.close(true);
            }
          });
      }
    });
  }

  public onPermissionsClick(): void {
    // open permissions dialog
    this._navigation.showFeedbackPermissionsEditor(this._applicationId, this._selectionStepId, ApplicationFeedbackType.ReferenceFeedback).subscribe();
  }

  public onPrintClick(): void {
    //to print
    this.formEditor.getFormInstance()?.print('/styles.css', `Feedback Request Users - ${this.userEmail}`);
  }

  public onCloseClick(): void {
    this.dialogRef.close(false);
  }
}

export interface ReferenceCheckRequestDialogData {
  feedbackRequestId: number;
  canLockFeedbackForm: boolean;
}

